import {
  LoadGenqlSelection,
  LoadLineItemGenqlSelection,
} from '@rematter/frontend-lib-api-client';

// 🟢🟢🟢 LINE ITEM
export const loadLineItemFragment = {
  id: true,
  itemId: true,
  type: true,
  loadId: true,
  salesOrderLineId: true,
  weights: true,
  unitPrice: {
    amount: true,
    currencyCode: true,
  },
  estimatedPrice: {
    amount: true,
  },
  item: {
    id: true,
    name: true,
    skuNumber: true,
    timestamps: {
      createdAt: true,
      updatedAt: true,
    },
  },
} satisfies LoadLineItemGenqlSelection;

// 🟢🟢🟢 SIMPLE LOAD
export const simpleLoadFragment = {
  id: true,
  status: true,
  expectedShipDate: true,
  containerNumber: true,
  releaseNumber: true,
  documentNumber: true,
  reviewed: true,
  lineItems: {
    id: true,
  },
  heavyWeight: {
    value: true,
    unit: true,
  },
  lightWeight: {
    value: true,
    unit: true,
  },
  timestamps: {
    createdAt: true,
    updatedAt: true,
  },
  booking: {
    id: true,
    documentNumber: true,
    vesselName: true,
  },
  salesOrder: {
    id: true,
    documentNumber: true,
    account: {
      id: true,
      name: true,
      phone: true,
      email: true,
      addresses: {
        address: {
          addressType: true,
          streetAddress: true,
          city: true,
          state: true,
          postalCode: true,
        },
      },
      contacts: {
        id: true,
        fullName: true,
        email: true,
        phone: true,
      },
    },
    counterpartyReferenceNumber: true,
  },
} satisfies LoadGenqlSelection;

// 🟢🟢🟢 FULL LOAD
export const fullLoadFragment = {
  ...simpleLoadFragment,
  deliveryNumber: true,
  sealNumber: true,
  containerTypeId: true,
  containerType: {
    id: true,
    name: true,
  },
  trailerNumber: true,
  truckNumber: true,
  recyclerExternalNotes: true,
  recyclerInternalNotes: true,
  customerExternalNotes: true,
  customerInternalNotes: true,
  loadReceivedDate: true,
  freightForwarder: true,
  canBeReconciled: true,
  isReconciled: true,
  reviewed: true,
  shippedDate: true,
  recyclerFiles: {
    id: true,
  },
  reconciliation: {
    receivedLineItems: {
      id: true,
      loadLineItemId: true,
      itemId: true,
      materialType: true,
      grossWeight: {
        value: true,
        unit: true,
      },
      tareWeight: {
        value: true,
        unit: true,
      },
      netWeight: {
        value: true,
        unit: true,
      },
      customerGrossWeight: {
        value: true,
        unit: true,
      },
      customerTareWeight: {
        value: true,
        unit: true,
      },
      unitPrice: {
        amount: true,
        currencyCode: true,
      },
      timestamps: {
        createdAt: true,
      },
    },
    deductions: {
      id: true,
      deductionTypeId: true,
      receivedLineItemId: true,
      weightQuantity: {
        value: true,
        unit: true,
      },
      priceQuantity: {
        amount: true,
        currencyCode: true,
      },
      timestamps: {
        createdAt: true,
      },
    },
  },
  lineItems: loadLineItemFragment,
} satisfies LoadGenqlSelection;
